// extracted by mini-css-extract-plugin
module.exports = {"maximalMobileWidth":"580px","maximalTabletWidth":"1024px","input":"Checkbox_input__nG5zr","main":"Checkbox_main__2ezXq"};